window.MECatalog = {
  "families": {
    "family-1000": {
      "supplier": "supplier-af",
      "label": "1000 Unisex Max Tee",
      "collectionHandle": "1000-unisex-max-tee",
      "colors": [
        {
          "name": "Oatmeal Heather",
          "handle": "1000-unisex-max-tee-oatmeal-heather"
        },
        {
          "name": "Red",
          "handle": "1000-unisex-max-tee-red"
        },
        {
          "name": "Royal",
          "handle": "1000-unisex-max-tee-royal"
        },
        {
          "name": "Sports Grey",
          "handle": "1000-unisex-max-tee-sports-grey"
        },
        {
          "name": "Charcoal Heather",
          "handle": "1000-unisex-max-tee-charcoal-heather"
        }
      ]
    },
    "family-1001": {
      "supplier": "supplier-af",
      "label": "1001 Premium Unisex Tee",
      "collectionHandle": "1001-premium-unisex-tee",
      "colors": [
        {
          "name": "Decadent Chocolate",
          "handle": "1001-premium-unisex-tee-decadent-chocolate"
        },
        {
          "name": "Texas Orange",
          "handle": "1001-premium-unisex-tee-texas-orange"
        },
        {
          "name": "Baby Pink",
          "handle": "1001-premium-unisex-tee-baby-pink"
        },
        {
          "name": "Sand",
          "handle": "1001-premium-unisex-tee-sand"
        },
        {
          "name": "Sawana Brown",
          "handle": "1001-premium-unisex-tee-sawana-brown"
        },
        {
          "name": "Yellow",
          "handle": "1001-premium-unisex-tee-yellow"
        },
        {
          "name": "Moss Green",
          "handle": "1001-premium-unisex-tee-moss-green"
        },
        {
          "name": "Lime Green",
          "handle": "1001-premium-unisex-tee-lime-green"
        },
        {
          "name": "Lavender",
          "handle": "1001-premium-unisex-tee-lavender"
        },
        {
          "name": "Dust",
          "handle": "1001-premium-unisex-tee-dust"
        },
        {
          "name": "Rust",
          "handle": "1001-premium-unisex-tee-rust"
        },
        {
          "name": "Maroon",
          "handle": "1001-premium-unisex-tee-maroon"
        },
        {
          "name": "Teal",
          "handle": "1001-premium-unisex-tee-teal"
        },
        {
          "name": "Peach",
          "handle": "1001-premium-unisex-tee-peach"
        },
        {
          "name": "Turquoise",
          "handle": "1001-premium-unisex-tee-turquoise"
        },
        {
          "name": "Camo",
          "handle": "1001-premium-unisex-tee-camo"
        },
        {
          "name": "Gold",
          "handle": "1001-premium-unisex-tee-gold"
        },
        {
          "name": "Pacific Blue",
          "handle": "1001-premium-unisex-tee-pacific-blue"
        },
        {
          "name": "Mint",
          "handle": "1001-premium-unisex-tee-mint"
        },
        {
          "name": "Coral",
          "handle": "1001-premium-unisex-tee-coral"
        },
        {
          "name": "Purple",
          "handle": "1001-premium-unisex-tee-purple"
        },
        {
          "name": "Orange",
          "handle": "1001-premium-unisex-tee-orange"
        },
        {
          "name": "Mustard",
          "handle": "1001-premium-unisex-tee-mustard"
        },
        {
          "name": "Kelly Green",
          "handle": "1001-premium-unisex-tee-kelly-green"
        },
        {
          "name": "Hot Pink",
          "handle": "1001-premium-unisex-tee-hot-pink"
        },
        {
          "name": "Burgundy",
          "handle": "1001-premium-unisex-tee-burgundy"
        },
        {
          "name": "Military Green",
          "handle": "1001-premium-unisex-tee-military-green"
        },
        {
          "name": "Royal",
          "handle": "1001-premium-unisex-tee-royal"
        },
        {
          "name": "Charcoal Heather",
          "handle": "1001-premium-unisex-tee-charcoal-heather"
        },
        {
          "name": "White",
          "handle": "1001-premium-unisex-tee-white"
        },
        {
          "name": "Pure Navy",
          "handle": "1001-premium-unisex-tee-pure-navy"
        },
        {
          "name": "Sports Grey",
          "handle": "1001-premium-unisex-tee-sports-grey"
        },
        {
          "name": "Black",
          "handle": "af-1001-black"
        },
        {
          "name": "Red",
          "handle": "1001-premium-unisex-tee-red"
        }
      ]
    },
    "family-1003": {
      "supplier": "supplier-af",
      "label": "1003 Unisex V-Neck Tee",
      "collectionHandle": "1003-unisex-v-neck-tee",
      "colors": [
        {
          "name": "Black",
          "handle": "1003-unisex-v-neck-tee-black",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/WhatsAppImage2023-02-11at12.45.04PM_1_6a4be7ce-1a5d-42f5-959c-2ee0b9d38662.jpg?v=1679385157"
        },
        {
          "name": "White",
          "handle": "1003-unisex-v-neck-tee-white",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/WhatsAppImage2023-02-11at12.45.04PM.jpg?v=1679385126"
        },
        {
          "name": "Navy",
          "handle": "1003-unisex-v-neck-tee-navy",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1003Navy.jpg?v=1696267575"
        },
        {
          "name": "Pink",
          "handle": "1003-unisex-v-neck-tee-pink",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1003-Baby-Pink.jpg?v=1696267767"
        },
        {
          "name": "Dust",
          "handle": "1003-unisex-v-neck-tee-dust",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1003-Dust.jpg?v=1696269826"
        },
        {
          "name": "Sports Grey",
          "handle": "1003-unisex-v-neck-tee-sports-grey",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1003-SportsGrey.jpg?v=1696270929"
        },
        {
          "name": "Charcoal Heather",
          "handle": "1003-unisex-v-neck-tee-charcoal-heather",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1003-CharcoalHeather.jpg?v=1696269756"
        }
      ]
    },
    "family-1004": {
      "supplier": "supplier-af",
      "label": "1004 Premium Long Sleeve Tee",
      "collectionHandle": "1004-premium-long-sleeve-tee",
      "colors": [
        {
          "name": "Black",
          "handle": "1004-premium-long-sleeve-tee-black",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/Untitleddesign_24.jpg?v=1628506560"
        },
        {
          "name": "White",
          "handle": "1004-premium-long-sleeve-tee-white",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/Untitleddesign-2021-08-03T093205.764.jpg?v=1627965152"
        },
        {
          "name": "Royal AM",
          "handle": "1004-premium-long-sleeve-tee-royal-am",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-RoyalAM.jpg?v=1696518727"
        },
        {
          "name": "Red",
          "handle": "1004-premium-long-sleeve-tee-red",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-red.jpg?v=1696518264"
        },
        {
          "name": "Charcoal",
          "handle": "1004-premium-long-sleeve-tee-charcoal",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-charcoal.jpg?v=1696518156"
        },
        {
          "name": "Navy",
          "handle": "1004-premium-long-sleeve-tee-navy",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-NAVY.jpg?v=1696518436"
        },
        {
          "name": "Dust PM",
          "handle": "1004-premium-long-sleeve-tee-dust-pm",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-DustPM.jpg?v=1696518401"
        },
        {
          "name": "Sports Grey",
          "handle": "1004-premium-long-sleeve-tee-sports-grey",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/1004-sportsgrey.jpg?v=1696519123"
        },
        {
          "name": "Neon Yellow",
          "handle": "1004-premium-long-sleeve-tee-neon-yellow",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/NeonYellow.jpg?v=1730827640"
        },
        {
          "name": "Neon Orange",
          "handle": "1004-premium-long-sleeve-tee-neon-orange",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/NeonOrange.jpg?v=1730827562"
        }
      ]
    },
    "family-1005": {
      "supplier": "supplier-af",
      "label": "1005 Women's Fitted Tee",
      "collectionHandle": "1005-womens-fitted-tee",
      "colors": [
        {
          "name": "Black",
          "handle": "1005-womens-fitted-tee-black",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_4.jpg?v=1630786804"
        },
        {
          "name": "White",
          "handle": "1005-womens-fitted-tee-white",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_1.jpg?v=1628067872"
        },
        {
          "name": "Royal",
          "handle": "1005-womens-fitted-tee-royal",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_5.jpg?v=1630699582"
        },
        {
          "name": "Red",
          "handle": "1005-womens-fitted-tee-red",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_6.jpg?v=1631260951"
        },
        {
          "name": "Burgundy",
          "handle": "1005-womens-fitted-tee-burgundy",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_3.jpg?v=1628068806"
        },
        {
          "name": "Hot Pink",
          "handle": "1005-womens-fitted-tee-hot-pink",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/WomenPink.jpg?v=1630777365"
        },
        {
          "name": "Purple",
          "handle": "1005-womens-fitted-tee-purple",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1005PURPLE.png?v=1650005651"
        },
        {
          "name": "Navy",
          "handle": "1005-womens-fitted-tee-navy",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1005navy1.jpg?v=1630521844"
        },
        {
          "name": "Turquoise",
          "handle": "1005-womens-fitted-tee-turquoise",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/files/GirlShirt.jpg?v=1686245947"
        },
        {
          "name": "Sports Grey",
          "handle": "1005-womens-fitted-tee-sports-grey",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1005.png?v=1653500081"
        },
        {
          "name": "Charcoal Heather",
          "handle": "1005-womens-fitted-tee-charcoal-heather",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1005grey.png?v=1653500034"
        },
        {
          "name": "Baby Pink",
          "handle": "1005-womens-fitted-tee-baby-pink",
          "image": "https://cdn.shopify.com/s/files/1/0431/6630/2373/products/1_2.jpg?v=1631296481"
        }
      ]
    },
    "family-2011": {
      "supplier": "supplier-af",
      "label": "2011 Superior Mid Weight Hoodie",
      "collectionHandle": "2011-superior-mid-weight-hoodie",
      "colors": [
        { "name": "White", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Royal Blue", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Black", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Red", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Charcoal Heather", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Navy", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Dust", "handle": "2011-superior-mid-weight-hoodie" },
        { "name": "Sports Grey", "handle": "2011-superior-mid-weight-hoodie" }
      ]
    },
    "family-2013": {
      "supplier": "supplier-af",
      "label": "2013 Superior Mid Weight Crew Sweatshirt",
      "collectionHandle": "2013-superior-mid-weight-crew-sweatshirt",
      "colors": [
        { "name": "Black", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "White", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Dust", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Royal Blue", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Red", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Navy", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Sports Grey", "handle": "2013-superior-mid-weight-crew-sweatshirt" },
        { "name": "Charcoal Heather", "handle": "2013-superior-mid-weight-crew-sweatshirt" }
      ]
    },
    "family-1007": {
      "supplier": "supplier-af",
      "label": "1007 Youth Premium Tee",
      "collectionHandle": "1007-youth-premium-tee",
      "colors": [
        {
          "name": "Black",
          "handle": "1007-youth-premium-tee-black"
        },
        {
          "name": "White",
          "handle": "1007-youth-premium-tee-white"
        },
        {
          "name": "Turquoise",
          "handle": "1007-youth-premium-tee-turquoise"
        },
        {
          "name": "Sports Grey",
          "handle": "1007-youth-premium-tee-sports-grey"
        },
        {
          "name": "Royal",
          "handle": "1007-youth-premium-tee-royal"
        },
        {
          "name": "Red",
          "handle": "1007-youth-premium-tee-red"
        },
        {
          "name": "Purple",
          "handle": "1007-youth-premium-tee-purple"
        },
        {
          "name": "Pacific Blue",
          "handle": "1007-youth-premium-tee-pacific-blue"
        },
        {
          "name": "Orange",
          "handle": "1007-youth-premium-tee-orange"
        },
        {
          "name": "Navy",
          "handle": "1007-youth-premium-tee-navy"
        },
        {
          "name": "Moss Green",
          "handle": "1007-youth-premium-tee-moss-green"
        },
        {
          "name": "Mint",
          "handle": "1007-youth-premium-tee-mint"
        },
        {
          "name": "Hot Pink",
          "handle": "1007-youth-premium-tee-hot-pink"
        },
        {
          "name": "Gold",
          "handle": "1007-youth-premium-tee-gold"
        },
        {
          "name": "Dust",
          "handle": "1007-youth-premium-tee-dust"
        },
        {
          "name": "Dark Navy",
          "handle": "1007-youth-premium-tee-dark-navy"
        },
        {
          "name": "Charcoal Heather",
          "handle": "1007-youth-premium-tee-charcoal-heather"
        },
        {
          "name": "Burgundy",
          "handle": "1007-youth-premium-tee-burgundy"
        },
        {
          "name": "Baby Pink",
          "handle": "1007-youth-premium-tee-baby-pink"
        }
      ]
    }
  }
};
